export default {
  turnLeftLabel: {
    id: 'vr_product360_turnleft_label',
    defaultMessage: 'Turn left',
  },
  turnRightLabel: {
    id: 'vr_product360_turnright_label',
    defaultMessage: 'Turn right',
  },
  fairLabel: {
    id: 'vr_product360_fair_label',
    defaultMessage: 'Fair',
  },
  goodLabel: {
    id: 'vr_product360_good_label',
    defaultMessage: 'Good',
  },
  excellentLabel: {
    id: 'vr_product360_excellent_label',
    defaultMessage: 'Excellent',
  },
  premiumLabel: {
    id: 'vr_product360_premium_label',
    defaultMessage: 'Premium',
  },
  screenTitle: {
    id: 'vr_product360_screen_title',
    defaultMessage: 'Screen',
  },
  screenTextFair: {
    id: 'vr_product360_screen_text_fair',
    defaultMessage:
      'May have light scratches that are slightly visible but won’t get in the way when the device is on.',
  },
  screenTextGood: {
    id: 'vr_product360_screen_text_good',
    defaultMessage: 'Flawless. No signs of use, no scratches, no nothing.',
  },
  screenTextExcellent: {
    id: 'vr_product360_screen_text_excellent',
    defaultMessage: 'Flawless. No signs of use, no scratches, no nothing.',
  },
  screenTextPremium: {
    id: 'vr_product360_screen_text_premium',
    defaultMessage: 'Flawless. No signs of use.',
  },
  bodyTitle: {
    id: 'vr_product360_body_title',
    defaultMessage: 'Body',
  },
  bodyTextFair: {
    id: 'vr_product360_body_text_fair',
    defaultMessage:
      'May have some signs of wear including scratches and dents. (Nothing a phone case can’t fix, right?)',
  },
  bodyTextGood: {
    id: 'vr_product360_body_text_good',
    defaultMessage:
      'Light signs of use. May have some faint scratches that aren’t noticeable at a glance, unless you put your nose to it.',
  },
  bodyTextExcellent: {
    id: 'vr_product360_body_text_excellent',
    defaultMessage:
      'Almost no signs of use. May have hairline scratches that are barely visible. You might strain your eyes just to spot them.',
  },
  bodyTextPremium: {
    id: 'vr_product360_body_text_premium',
    defaultMessage:
      'No signs of use. Premium devices may be gently used or open-box returns.',
  },
  hardwareTitle: {
    id: 'vr_product360_hardware_title',
    defaultMessage: 'Hardware',
  },
  hardwareTextFair: {
    id: 'vr_product360_hardware_text_fair',
    defaultMessage:
      '100% fully functional. Tested, checked, and cleaned by professional refurbishers who are vetted by Back Market.',
  },
  hardwareTextGood: {
    id: 'vr_product360_hardware_text_good',
    defaultMessage:
      '100% fully functional. Tested, checked, and cleaned by professional refurbishers who are vetted by Back Market.',
  },
  hardwareTextExcellent: {
    id: 'vr_product360_hardware_text_excellent',
    defaultMessage:
      '100% fully functional. Tested, checked, and cleaned by professional refurbishers who are vetted by Back Market.',
  },
  hardwareTextPremium: {
    id: 'vr_product360_hardware_text_premium',
    defaultMessage:
      '100% fully functional. Genuine manufacturer-issued parts. Tested, checked, and cleaned by professional refurbishers.',
  },
  batteryTitle: {
    id: 'vr_product360_battery_title',
    defaultMessage: 'Battery',
  },
  batteryTextSmartphonesFair: {
    id: 'vr_product360_battery_text_smartphones_fair',
    defaultMessage:
      'Good health: minimum 80% battery capacity. Good performance for average daily use.',
  },
  batteryTextSmartphonesGood: {
    id: 'vr_product360_battery_text_smartphones_good',
    defaultMessage:
      'Good health: minimum 80% battery capacity. Good performance for average daily use.',
  },
  batteryTextSmartphonesExcellent: {
    id: 'vr_product360_battery_text_smartphones_excellent',
    defaultMessage:
      'Good health: minimum 80% battery capacity. Good performance for average daily use.',
  },
  batteryTextSmartphonesPremium: {
    id: 'vr_product360_battery_text_smartphones_premium',
    defaultMessage:
      'Great health: Genuine manufacturer-issued battery with minimum 90% capacity. Great performance for heavy daily use.',
  },
  batteryTextTabletsFair: {
    id: 'vr_product360_battery_text_tablets_fair',
    defaultMessage:
      'Good health: minimum 80% battery capacity. Good performance for average daily use.',
  },
  batteryTextTabletsGood: {
    id: 'vr_product360_battery_text_tablets_good',
    defaultMessage:
      'Good health: minimum 80% battery capacity. Good performance for average daily use.',
  },
  batteryTextTabletsExcellent: {
    id: 'vr_product360_battery_text_tablets_excellent',
    defaultMessage:
      'Good health: minimum 80% battery capacity. Good performance for average daily use.',
  },
  batteryTextTabletsPremium: {
    id: 'vr_product360_battery_text_tablets_premium',
    defaultMessage:
      'Great health: Genuine manufacturer-issued battery with minimum 90% capacity. Great performance for heavy daily use.',
  },
  batteryTextLaptopsFair: {
    id: 'vr_product360_battery_text_laptops_fair',
    defaultMessage:
      'Good health: minimum 80% battery capacity. Good performance for average daily use.',
  },
  batteryTextLaptopsGood: {
    id: 'vr_product360_battery_text_laptops_good',
    defaultMessage:
      'Good health: minimum 80% battery capacity. Good performance for average daily use.',
  },
  batteryTextLaptopsExcellent: {
    id: 'vr_product360_battery_text_laptops_excellent',
    defaultMessage:
      'Good health: minimum 80% battery capacity. Good performance for average daily use.',
  },
  batteryTextLaptopsPremium: {
    id: 'vr_product360_battery_text_laptops_premium',
    defaultMessage:
      'Great health: Genuine manufacturer-issued battery with minimum 90% capacity. Great performance for heavy daily use.',
  },
  batteryTextGamingConsolesFair: {
    id: 'vr_product360_battery_text_gaming_consoles_fair',
    defaultMessage:
      'Good health: minimum 80% battery capacity. Good performance for average daily use.',
  },
  batteryTextGamingConsolesGood: {
    id: 'vr_product360_battery_text_gaming_consoles_good',
    defaultMessage:
      'Good health: minimum 80% battery capacity. Good performance for average daily use.',
  },
  batteryTextGamingConsolesExcellent: {
    id: 'vr_product360_battery_text_gaming_consoles_excellent',
    defaultMessage:
      'Good health: minimum 80% battery capacity. Good performance for average daily use.',
  },
  batteryTextGamingConsolesPremium: {
    id: 'vr_product360_battery_text_gaming_consoles_premium',
    defaultMessage:
      'Great health: Genuine manufacturer-issued battery with minimum 90% capacity. Great performance for heavy daily use.',
  },
  batteryTextSmartwatchesFair: {
    id: 'vr_product360_battery_text_smartwatches_fair',
    defaultMessage:
      'Good health: minimum 80% battery capacity. Good performance for average daily use.',
  },
  batteryTextSmartwatchesGood: {
    id: 'vr_product360_battery_text_smartwatches_good',
    defaultMessage:
      'Good health: minimum 80% battery capacity. Good performance for average daily use.',
  },
  batteryTextSmartwatchesExcellent: {
    id: 'vr_product360_battery_text_smartwatches_excellent',
    defaultMessage:
      'Good health: minimum 80% battery capacity. Good performance for average daily use.',
  },
  batteryTextSmartwatchesPremium: {
    id: 'vr_product360_battery_text_smartwatches_premium',
    defaultMessage:
      'Great health: Genuine manufacturer-issued battery with minimum 90% capacity. Great performance for heavy daily use.',
  },
  startZoomLabel: {
    id: 'vr_product360_start_zoom_label',
    defaultMessage: 'Zoom in',
  },
  stopZoomLabel: {
    id: 'vr_product360_stop_zoom_label',
    defaultMessage: 'Reset',
  },
  smartphones: {
    id: 'vr_smartphones_title',
    defaultMessage: 'smartphones',
  },
  laptops: {
    id: 'vr_laptops_title',
    defaultMessage: 'laptops',
  },
  tablets: {
    id: 'vr_tablets_title',
    defaultMessage: 'tablets',
  },
  consoles: {
    id: 'vr_gaming_consoles_title',
    defaultMessage: 'gaming consoles',
  },
  smartwatches: {
    id: 'vr_smartwatches_title',
    defaultMessage: 'smartwatches',
  },
} as const
